import { replaceVariableWithName } from '@/common/utils/question-variable';

export const ReplaceVariableByUser = (text, user) => user ? replaceVariableWithName(text, user, user.manager) : text;
